import { render } from "./SignUpKyc2.vue?vue&type=template&id=759ac4a7&scoped=true&ts=true"
import script from "./SignUpKyc2.vue?vue&type=script&lang=ts"
export * from "./SignUpKyc2.vue?vue&type=script&lang=ts"

import "./SignUpKyc2.vue?vue&type=style&index=0&id=759ac4a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759ac4a7"]])

export default __exports__